import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>
                <small>
                    Elena CK &copy;
                </small>
            </p>
        </footer>
    );
};

export default Footer;